export interface ImageCardDataProps {
  id: number;
  title: string;
  imageSrc: string;
}

const imageCardData = [
  {
    id: 1,
    title: ".NET",
    imageSrc: "/Photos/DotNETLogo.png",
  },
  {
    id: 2,
    title: "C#",
    imageSrc: "/Photos/CSharpLogo.png",
  },
  {
    id: 5,
    title: "Javascript",
    imageSrc: "/Photos/JavascriptModifiedLogo.png",
  },
  {
    id: 6,
    title: "React",
    imageSrc: "/Photos/ReactLogo.png",
  },
  {
    id: 9,
    title: "SQL",
    imageSrc: "/Photos/SQLLogo.jpg",
  },
  {
    id: 4,
    title: "Entity Framework",
    imageSrc: "/Photos/EntityFrameworkLogo.png",
  },
  {
    id: 100,
    title: "Dapper",
    imageSrc: "/Photos/DapperLogo.png",
  },
  {
    id: 120,
    title: "PostgresSQL",
    imageSrc: "/Photos/PostgresSQLLogo.png",
  },
  {
    id: 10,
    title: "MongoDb",
    imageSrc: "/Photos/MongoDbLogo.png",
  },
  {
    id: 15,
    title: "Azure",
    imageSrc: "/Photos/AzureLogo.png",
  },
  {
    id: 155,
    title: "Heroku",
    imageSrc: "/Photos/HerokuLogo.png",
  },
  {
    id: 1555,
    title: "Netlify",
    imageSrc: "/Photos/NetlifyLogo.png",
  },
  {
    id: 16,
    title: "TypeScript",
    imageSrc: "/Photos/TypeScriptLogo.png",
  },

  {
    id: 7,
    title: "Git",
    imageSrc: "/Photos/GitLogo.png",
  },
  {
    id: 8,
    title: "GitHub",
    imageSrc: "/Photos/GitHubLogo.png",
  },
  {
    id: 3,
    title: "Blazor",
    imageSrc: "/Photos/BlazorLogo.png",
  },
  {
    id: 11,
    title: "HTML 5",
    imageSrc: "/Photos/HTML5Logo.png",
  },
  {
    id: 12,
    title: "CSS 3",
    imageSrc: "/Photos/CSSLogo.png",
  },
  {
    id: 13,
    title: "Material UI",
    imageSrc: "/Photos/MaterialUILogo.png",
  },
  {
    id: 14,
    title: "BootStrap",
    imageSrc: "/Photos/BootstrapLogo.png",
  },
];

export default imageCardData;
